export default "__VITE_ASSET__CWNJN1BF__"